
function populateCartCustomData(rebuyCart) {
    rebuyCart.items().forEach(element => {
        if (! element.product) return;

        window.Rebuy.cartProductsLoaded = true;
        const productVariant = element.product.selected_variant;
        if (! productVariant) return;

        // Remind our customer that their product will be shipped at later date
        if (productVariant.inventory_policy == 'continue' && productVariant.inventory_quantity <= 0) {
            if (productVariant.metafields && 'custom' in productVariant.metafields) {
                element.backorder_message = productVariant.metafields['custom']['backorder_msg'];

                // Dirty hack since I don't know how to trigger update to the view without changing 'variant_title' value
                element.variant_title = productVariant.title + " ";
            } else {
                console.log("No 'custom' metafield found!", productVariant.metafields);
            }
        }
    });
}

function onRbCartReady(event) {
    const rbCart = window.Rebuy.Cart;
    populateCartCustomData(rbCart);
};

function onRbCartChanged(event) {
    window.Rebuy.cartProductsLoaded = false;

    // It takes a while before Rb Cart items.product were loaded
    const intervalId = setInterval(() => {
        if (!window.Rebuy.cartProductsLoaded) {
            const rbCart = window.Rebuy.Cart;
            populateCartCustomData(rbCart);
        } else {
            clearInterval(intervalId);
        }
    }, 100);

    setTimeout(() => {
        clearInterval(intervalId);
    }, 3000);
};

document.addEventListener('rebuy:cart.ready', onRbCartReady);
document.addEventListener('rebuy:cart.change', onRbCartChanged);
